// src/pages/NotAuthorized.jsx

import React from 'react';

function NotAuthorized() {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h2>Niste ovlašteni za pristup ovoj stranici.</h2>
      <p>Molimo kontaktirajte administratora za dodatne informacije.</p>
    </div>
  );
}

export default NotAuthorized;
